import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, OccConfig } from '@spartacus/core';
import { UigEtilizeRedirectComponent } from './uig-etilize-redirect.component';
import { SpinnerModule } from '@spartacus/storefront';
import { UigEtilizeRedirectAdapter } from './uig-etilize-redirect.adapter';



@NgModule({
  declarations: [
    UigEtilizeRedirectComponent
  ],
  imports: [
    CommonModule,
    SpinnerModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig | OccConfig>{
      cmsComponents: {
        EtilizeRedirectComponent: {
          component: UigEtilizeRedirectComponent
        }
      },
      backend: {
        occ: {
          endpoints: {
            etilizeRedirect: 'sso/etilize/start'
          },
        },
      },
    })
  ],
  providers: [
    {
      provide: UigEtilizeRedirectAdapter,
      useClass: UigEtilizeRedirectAdapter
    }
  ]
})
export class UigEtilizeRedirectModule { }
